module.exports = __webpack_public_path__ + "static/media/13ITC2.aa6b0da2.jpg";